function intakeBlocksOnInit(){

    initSwiper();

    jQuery( window ).resize(function() {
        initSwiper();
    });
}

function intakeBlocksOnComplete(){
    initSwiper();
}

var $car = [];
function initSwiper(){
    if(jQuery('.block.intake-blocks')[0]){
        if(jQuery(document).width() < 850) { 
            jQuery('.block.intake-blocks .swiper-container').each(function(i){
                $car[i] = new Swiper(this, {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 18,
                    initialSlide: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                });
            });
        } else if (jQuery(document).width() > 851 && $car[0] != undefined) {

            for (var i = 0; i < $car.length; i++) {
                $car[i].destroy();
                $car[i] = undefined;
            }

            jQuery('.block.intake-blocks .swiper-wrapper').removeAttr('style');
            jQuery('.block.intake-blocks .swiper-slide').removeAttr('style');
        }
    }
}
